import { SharedState } from "@/common/state";
import {
  DuplicatedDashboardItem,
  FileLabelingDashboardItem,
  FilesAgeDashboardItem,
  FileSearchItem,
  FilesInformationBoardItem,
} from "./model";
import { apiCall } from "@/common/api/ApiResult.model";
import { delayBy } from "@/fp";
import { ListResult } from "@/common/models";
import { ICONS } from "@/common/icons.map";

type BaseInput = {
  session_id: string;
  root_folder_id: string;
};

export const get_duplicated_items = apiCall<
  BaseInput,
  DuplicatedDashboardItem[]
>("on-prem.get_duplicated_items", async () => {
  await delayBy(2000);
  return {
    success: true,
    value: [],
  };
});

export const get_file_labeling = apiCall<
  BaseInput,
  FileLabelingDashboardItem[]
>("on-prem.get_files_labeling", async () => {
  await delayBy(2000);
  return {
    success: true,
    value: SharedState.l0_known_content_info_types.value.map((d) => {
      const total = 100;
      return {
        id: d.id,
        name: d.labelName,
        total,
        cant_be_labelled: 25,
        labeled: 50,
        unlabelled: 25,
      } as FileLabelingDashboardItem;
    }),
  };
});

export const get_l0_file_labeling = apiCall<
  BaseInput & { label_id: string },
  FileLabelingDashboardItem[]
>(
  "on-prem.get_files_labeling",
  async ({ label_id, root_folder_id, session_id }) => {
    await delayBy(2000);
    return {
      success: true,
      value: SharedState.info_types_tree.value
        .find((d) => d.id == label_id)!
        .nested.map((d) => {
          const total = 100;
          return {
            id: d.id,
            name: d.labelName,
            total,
            cant_be_labelled: 25,
            labeled: 50,
            unlabelled: 25,
          } as FileLabelingDashboardItem;
        }),
    };
  }
);

export const get_files_age = apiCall<BaseInput, FilesAgeDashboardItem[]>(
  "on-prem.get_files_labeling",
  async () => {
    return {
      success: true,
      value: [],
    };
  }
);

export const search_file = apiCall<
  BaseInput & { query: string; cursor: string },
  ListResult<FileSearchItem>
>(
  "on-prem.search_files",
  async ({ query, root_folder_id, session_id, cursor }) => {
    await delayBy(1000);
    // Addendums & Appendixes
    const some_agreement_label = SharedState.getInfoType(
      "12c44622-b8f5-0220-4d61-06c1e41c8871"
    )!;
    return {
      success: true,
      value: {
        cursor: "",
        objects: Array(20)
          .fill({})
          .map((_, index) => {
            return {
              id: index + +"_id" + cursor,
              name: "some_file_name_" + index + ".pdf",
              path: "this/is/the/path/to/the/file/which/is/something/very/long",
              label: {
                id: some_agreement_label.id,
                code: some_agreement_label.code,
                name: some_agreement_label.labelName,
                sensitivity: some_agreement_label.sensitivityLevel,
                // @ts-ignore
                path: some_agreement_label.path
                  .slice(0, -1)
                  .map(
                    (id: string) => SharedState.allInfoTypes.value[id].labelName
                  )
                  .join("/"),
              },
            };
          }),
      },
    };
  }
);

export const get_sensitive_information_board = apiCall<
  BaseInput,
  FilesInformationBoardItem[]
>("on-prem.get_information_board", async () => {
  await delayBy(2000);
  // using findings api to get the results for All of the label ids
  return {
    success: true,
    value: SharedState.l0_known_content_info_types.value
      .filter((d) => d.code !== 7)
      .map((d) => {
        return {
          id: d.id,
          name: d.labelName,
          icon: ICONS.L0_ICONS.get(d.code),
          items: SharedState.info_types_tree.value
            .find((l) => l.id == d.id)!
            .nested.map((l1) => {
              return {
                id: l1.id,
                count: Math.floor(Math.random() * 10_000),
                name: l1.labelName,
                items: [],
              };
            })
            .sort((a, b) => b.count - a.count),
        };
      }),
  };
});

export const get_personal_information_board = apiCall<
  BaseInput,
  FilesInformationBoardItem[]
>("on-prem.get_information_board", async () => {
  await delayBy(2000);
  // using findings api to get the results for All of the label ids
  return {
    success: true,
    value: [],
  };
});
